import React, { useState } from 'react';
import './Downloads.css';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import Header from './Header';

const Downloads = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const resources = [
    {
      name: 'Matemática 9ª Classe',
      description: 'Livro de Matemática para a 9ª classe, cobrindo álgebra e geometria.',
      year: 2023,
      uploadedBy: 'João Silva',
      type: 'Livro',
      link: '/downloads/matematica_9_classe.pdf',
    },
    {
      name: 'Foto Evento Escolar 2024',
      description: 'Foto do evento escolar realizado em Maputo.',
      year: 2024,
      uploadedBy: 'Maria Santos',
      type: 'Foto',
      link: '/downloads/evento_escolar_2024.jpg',
    },
    {
      name: 'Português 10ª Classe',
      description: 'Livro de Português com foco em gramática e literatura moçambicana.',
      year: 2022,
      uploadedBy: 'Ana Pereira',
      type: 'Livro',
      link: '/downloads/portugues_10_classe.pdf',
    },
    {
      name: 'Foto Aula Prática 2023',
      description: 'Foto de uma aula prática de ciências no laboratório.',
      year: 2023,
      uploadedBy: 'Carlos Mendes',
      type: 'Foto',
      link: '/downloads/aula_pratica_2023.jpg',
    },
  ];

  const filteredResources = resources.filter((resource) =>
    resource.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    resource.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Head */}
      {/* <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <img src="/images/Asset7.png" alt="Academia Logo" className="logo-img" />
            <span>O Conteúdo que Precisas</span>
          </div>
          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-twitter icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section> */}

      {/* Header */}
      {/* <header>
        <nav className="flexSB">
          <ul className="flexSB">
            <li><a href="/">Início</a></li>
            <li><a href="/quem-somos">Quem Somos</a></li>
            <li><a href="/conteudo">Conteúdo</a></li>
            <li><a href="/downloads">Downloads</a></li>
            <li><a href="/contacto">Contacte-nos</a></li>
          </ul>
          <div className="start">
            <a href="/login" className="button">Iniciar Sessão</a>
          </div>
        </nav>
      </header> */}
            {/* <header>
      <nav className="flexSB">
        <ul className="flexSB">
          <li><Link to="/" className='lol'>Início</Link></li>
          <li><Link to="/AboutUs">Quem Somos</Link></li>
          <li><Link to="/ContentPage">Conteúdo</Link></li>
          <li><Link to="/ContactUs">Contacte-nos</Link></li>
          <li><Link to="/Downloads">Baixe Coisas</Link></li>
        </ul>
        <div className="start">
          <Link to="/Login" className="button">Iniciar Sessão</Link>
        </div>
      </nav>
    </header> */}
      <Header/>
      {/* Seção Downloads */}
      <section className="downloads-section">
        <div className="container">
          <h2>Downloads</h2>
          <div className="search-bar">
            <input
              type="text"
              placeholder="Pesquisar recursos..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="resources-list">
            {filteredResources.length > 0 ? (
              filteredResources.map((resource, index) => (
                <div key={index} className="resource-item">
                  <h3>{resource.name}</h3>
                  <p><strong>Descrição:</strong> {resource.description}</p>
                  <p><strong>Ano:</strong> {resource.year}</p>
                  <p><strong>Enviado por:</strong> {resource.uploadedBy}</p>
                  <p><strong>Tipo:</strong> {resource.type}</p>
                  <a href={resource.link} download className="download-btn">
                    Baixar
                  </a>
                </div>
              ))
            ) : (
              <p>Nenhum recurso encontrado para "{searchTerm}".</p>
            )}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Downloads;